const globalHeader = document.querySelector('.global-header');
const main = document.querySelector('main');
const header = document.querySelector('header');
const headerResetDelay = 100;

const resetBodyPadding = function () {
  if (main) {
    main.style.paddingTop = `${globalHeader.offsetHeight}px`;
  }
};

export default function initializeHeader() {
  setTimeout(() => {
    resetBodyPadding();
  }, headerResetDelay);

  window.addEventListener('resize', resetBodyPadding);

  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(entries => {
      resetBodyPadding();
    });
    resizeObserver.observe(header);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', resetBodyPadding);
    };
  }
};